export default {
  crmRoles: [],
  operationMenu: [],
  dataMenu: [],

  // 已登录
  authenticated: false,

  // 自由访问页面
  freePages: ["/test", "/404"],

  // 用户信息
  userInfo: {},

  // 基础权限
  authority: {},
  // 团队
  backTeamList: {},

  // 客户权限
  customAuth: {},
  medicalCustomAuth: {},
  // 快捷新增对应权限
  quickAuth: {},
  // 产品线管理
  productManageAuth: {},
  // 拜访
  visitAuth: {},
  // 合同
  contractAuth: {},
  // 商机
  businessAuth: {},
};
